import React, { useState } from 'react'
import { IconContext } from 'react-icons'
import { IconTooltip as Tooltip } from '../Tooltip'
import { FaCompressArrowsAlt, FaExpandArrowsAlt } from 'react-icons/fa'

const ExpandButton = ({ name, inHeader = true, isExpanded, setIsExpanded }) => {
    const handleClick = () => setIsExpanded(current => !current)

    return (
        <>
            <IconContext.Provider
                value={{
                    className: `panelHeaderIcon`,
                }}
            >
                <span
                    onClick={handleClick}
                    className={`${
                        inHeader ? 'panelHeaderIconDiv' : 'clickable'
                    }`}
                    data-tip={`${
                        isExpanded ? `Collapse` : `Expand to Full Screen`
                    }`}
                    data-for={`${name}-expanded-${isExpanded}`}
                >
                    {isExpanded ? (
                        <FaCompressArrowsAlt />
                    ) : (
                        <FaExpandArrowsAlt />
                    )}
                </span>
            </IconContext.Provider>
            <Tooltip id={`${name}-expanded-${isExpanded}`} />
        </>
    )
}

export default ExpandButton
